<template>
  <footer id="community-spotlight" class="blog-post__footer clearfix">
    <div class="blog-post__footer-top">
      <h2 class="blog-post__footer-header">
        <i class="iconmoon-share"></i>
        <span>Share this post:</span>
      </h2>

      <SharedButtons :post="post"></SharedButtons>
    </div>
    <a
      href="#"
      class="back-top iconmoon-backtotop pull-right"
      @click.stop.prevent="scrollToTop()"
    ></a>
  </footer>
</template>
<script>
import SharedButtons from "./SharedButtons";

export default {
  components: {
    SharedButtons
  },
  props: {
    post: Object,
    scrollTopId: String
  },
  data() {
    return {
      collapsed: true
    };
  },
  methods: {
    scrollToTop() {
      let to = 0;
      let duration = 1050;
      let start = Math.max(
          window.pageYOffset,
          document.documentElement.scrollTop,
          document.body.scrollTop
        ),
        change = to - start,
        currentTime = 0,
        increment = 20;
      let easeInOutQuad = function(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };
      let animateScroll = function() {
        currentTime += increment;
        let val = easeInOutQuad(currentTime, start, change, duration);
        document.body.scrollTop = val;
        document.documentElement.scrollTop = val;
        if (currentTime < duration) {
          setTimeout(animateScroll, increment);
        }
      };
      animateScroll();
    }
  }
};
</script>
